module.exports = __webpack_public_path__ + "static/media/HCMM634.f64bb12b.jpg";